import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PaginatorModel } from 'symbols';
import { MediatorModel } from '../symbols';

@Injectable()
export class MediatorService {
  private readonly apiUrl = '/api/mediators';

  constructor(private http: HttpClient) {
  }

  getMediators(search?: string, maxLimit = 20): Observable<MediatorModel[]> {
    return this.http.get<PaginatorModel<MediatorModel>>(`${this.apiUrl}`, {
      params: {
        search,
        'filter.limit': maxLimit
      }
    })
      .pipe(
        map(m => m.data)
      );
  }

}
